/* Ability Warehouse — "Price Flip" membership sheet (v39).
   Two moments, both additive to the existing membership flow (nothing is ever added unless the shopper taps Yes):
   1. Add to cart (buy card button OR the mobile sticky bar, which submits the same form) with the membership box UNticked,
      on a product the member discount applies to → the sheet opens instead of adding.
        Yes  → ticks the existing box ([data-tog-input]) and re-submits: cart-drawer.js's own "box ticked" handler adds the
               product + membership in one /cart/add.js, applies the new-member code and opens the drawer.
        Skip → re-submits unchanged: the normal add-to-cart (product only, standard price) + drawer. No more add sheets this session.
   2. Checkout (drawer or cart page) with no membership in the cart and eligible items → the sheet opens (once per session).
        Yes  → ticks the existing yellow bar ([data-mt-chk]) and re-clicks Checkout: cart-drawer.js adds the membership,
               swaps the Checkout link to the member code and goes to checkout once the cart is updated.
        Skip → goes to checkout exactly as before.
   Listeners run on window in the capture phase so they see the submit/click before cart-drawer.js and pdp.js. */
(function () {
  'use strict';
  var el = document.querySelector('[data-awms]');
  if (!el || (window.CW && window.CW.member)) return;
  var sheet = el.querySelector('.awms__sheet');
  var yesBtn = el.querySelector('[data-awms-yes]');
  var KEY_ADD = 'aw_ms_add_skipped', KEY_CO = 'aw_ms_co_shown';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var money = function (c) { return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format((c || 0) / 100); };
  function flag(k) { try { return window.sessionStorage.getItem(k) === '1'; } catch (e) { return false; } }
  function setFlag(k) { try { window.sessionStorage.setItem(k, '1'); } catch (e) {} }

  var cur = null, lastFocus = null, bypass = false, hideT = 0;

  function show(o) {
    clearTimeout(hideT);
    cur = o;
    el.querySelector('[data-awms-std]').textContent = money(o.std);
    el.querySelector('[data-awms-mem]').textContent = money(o.std - o.save);
    el.querySelector('[data-awms-save]').textContent = money(o.save);
    var q = el.querySelector('[data-awms-qty]');
    if (q) { q.hidden = !(o.qty > 1); q.textContent = o.qty > 1 ? 'for ' + o.qty + ' items' : ''; }
    yesBtn.textContent = 'Yes, save ' + money(o.save) + (o.mode === 'co' ? ' & checkout' : ' & add');
    lastFocus = document.activeElement;
    el.classList.remove('is-open');
    el.hidden = false;
    void el.offsetWidth; /* restart the animations */
    el.classList.add('is-open');
    document.documentElement.classList.add('awms-lock');
    try { sheet.focus({ preventScroll: true }); } catch (e) { sheet.focus(); }
  }
  function close(choice) {
    if (!cur) return;
    var o = cur; cur = null;
    el.classList.remove('is-open');
    document.documentElement.classList.remove('awms-lock');
    hideT = setTimeout(function () { if (!cur) el.hidden = true; }, reduce ? 0 : 320);
    if (lastFocus && document.contains(lastFocus) && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    (choice === 'yes' ? o.onYes : o.onSkip)();
  }

  el.addEventListener('click', function (e) {
    if (e.target.closest('[data-awms-yes]')) { close('yes'); return; }
    if (e.target.closest('[data-awms-skip]')) close('skip');
  });
  window.addEventListener('keydown', function (e) {
    if (!cur) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopImmediatePropagation(); close('skip'); return; } /* the cart drawer stays open */
    if (e.key !== 'Tab') return;
    var f = Array.prototype.slice.call(sheet.querySelectorAll('button, a[href]')).filter(function (x) { return !x.disabled && x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (e.shiftKey && (a === first || a === sheet || !sheet.contains(a))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (a === last || !sheet.contains(a))) { e.preventDefault(); first.focus(); }
  }, true);

  /* ---------- 1. Add to cart ---------- */
  var root = document.querySelector('[data-pdp]');
  var base = root ? +root.dataset.base || 0 : 0;
  document.addEventListener('aw:variant', function (e) { var v = e.detail || {}; if (v.id && v.price != null) base = +v.price || base; });
  function membershipInCart() {
    var inner = document.querySelector('[data-cart-drawer] [data-cd-inner]');
    return !!(inner && inner.dataset.mkeys);
  }
  function resubmit(form, btn) {
    bypass = true;
    try {
      if (form.requestSubmit) form.requestSubmit(btn && btn.form === form && btn.type === 'submit' ? btn : undefined);
      else (btn || form.querySelector('[type="submit"]')).click();
    } finally { bypass = false; }
  }
  window.addEventListener('submit', function (e) {
    if (bypass || cur) return;
    var form = e.target;
    if (!form.matches || !form.matches('[data-pdp] form[data-calc]')) return;
    var r = form.closest('[data-pdp]'), tog = r.querySelector('[data-tog-input]');
    if (!tog || tog.checked) return; /* ticked: proceed as today */
    var d = r.dataset;
    if (d.noSale === 'true' || d.locked === 'true' || d.member === 'true' || el.dataset.gift === 'true' || d.handle === 'membership') return;
    if (flag(KEY_ADD) || membershipInCart() || r.hasAttribute('data-mem-cart')) return; /* data-mem-cart: aw-pdp-mem.js, the shopper already chose in/out */
    var addBtn = form.querySelector('[data-add]');
    if (addBtn && addBtn.disabled) return;
    /* Same maths as pdp.js: standard = price less any sale %, member = price less the member % */
    var pct = +d.memberPct || 10, sale = +d.salePct || 0;
    var n = Math.max(1, parseInt((form.querySelector('input[name="quantity"]') || {}).value, 10) || 1);
    var g = Math.round(base * (100 - sale) / 100), m = Math.round(base * (100 - pct) / 100);
    var save = Math.max(0, g - m) * n;
    if (!base || save <= 0) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var btn = e.submitter || addBtn;
    show({
      mode: 'add', std: g * n, save: save, qty: n,
      onYes: function () {
        tog.checked = true;
        tog.dispatchEvent(new Event('change', { bubbles: true })); /* pdp.js repaints the buy card + sticky bar */
        resubmit(form, btn); /* cart-drawer.js: product + membership, member code, drawer opens */
      },
      onSkip: function () { setFlag(KEY_ADD); resubmit(form, btn); }
    });
  }, true);

  /* ---------- 2. Checkout ---------- */
  window.addEventListener('click', function (e) {
    if (bypass || cur || e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href*="/discount/"][href*="checkout"]');
    if (!a) return;
    var scope = a.closest('[data-cd-inner]') || a.closest('section.cart');
    if (!scope) return;
    var bar = scope.querySelector('[data-mt]');
    if (!bar || bar.classList.contains('is-locked')) return;
    var chk = bar.querySelector('[data-mt-chk]');
    if (!chk || chk.checked || membershipInCart() || flag(KEY_CO)) return;
    var std = +bar.dataset.sheetStd || 0, save = +bar.dataset.sheetSave || 0;
    if (save <= 0 || std <= save) return;
    e.preventDefault(); e.stopImmediatePropagation();
    setFlag(KEY_CO);
    show({
      mode: 'co', std: std, save: save, qty: 1,
      onYes: function () {
        chk.checked = true;
        chk.dispatchEvent(new Event('change', { bubbles: true })); /* cart-drawer.js adds the membership + swaps the link to the member code */
        bypass = true;
        try { a.click(); } finally { bypass = false; } /* cart-drawer.js waits for the cart update, then follows the link */
      },
      onSkip: function () { location.href = a.href; }
    });
  }, true);
})();
